// import PropTypes from 'prop-types';
import ArtistCard from '../ArtistCard/ArtistCard';
import styles from './ArtistCardList.module.scss';

const ArtistCardList = ({ items, isLoading = false }) => {
    return (
        <div className={styles['ArtistCardList']}>
            <div className={styles['ArtistCardList__Container']}>
                <div className={styles['ArtistCardList__List']}>
                    {isLoading &&
                        Array(4)
                            .fill()
                            .map((item, index) => (
                                <ArtistCard
                                    key={index}
                                    isLoading={true}
                                    title={''}
                                    tags={[]}
                                    associatedActs={''}
                                    image={{}}
                                    preamble={''}
                                    link={{}}
                                />
                            ))}
                    {!isLoading &&
                        items?.map((item, i) => (
                            <div
                                key={i}
                                className={styles['ArtistCardList__Item']}>
                                <ArtistCard {...item} />
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
};

ArtistCardList.propTypes = {};

export default ArtistCardList;
